export default __webpack_public_path__ + "static/media/25.e606140c.jpg";